import useFetchList from "./useFetchList";

export interface Country {
    id: string;
    name: string;
    code: string;
}

interface CountryApiResponse {
    COUNTRY_ISO_ID: string;
    LOCAL_CODE: string;
}

const mapCountries = (items: CountryApiResponse[]): Country[] =>
    items.map((c) => ({
        id: c.COUNTRY_ISO_ID,
        name: c.LOCAL_CODE,
        code: c.COUNTRY_ISO_ID,
    }));

const useGetCountries = () => {
    const { data, loading, error } = useFetchList<CountryApiResponse, Country>({
        endpoint: "/getAllCountries",
        transform: mapCountries,
    });
    return { data, loading, error };
};

export default useGetCountries;
